@use "../../variables" as *;
@use "../../mixins" as *;

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  position: sticky;
  position: -webkit-sticky;
  top: 4rem;
  z-index: 2;
  background-color: white;
  transition: all .5s ease;
  flex-direction: row;

  @include mobile {
    flex-direction: column;
    align-items: flex-start;
    top: 4rem;
  }

  .header-inner-container-desktop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1rem;
    margin-bottom: 0.875rem;

    &.with-info {
      align-items: unset;
    }

    @include tablet {
      margin-bottom: 0;
    }
  }

  .title-container {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      font-size: 1.125rem;
      line-height: 1.125rem;
      color: $grey;
      align-self: start;
    }

    .close {
      position: absolute;
      left: 0;
      height: 1rem;
      justify-self: flex-start;
    }
  }

  @include tablet {
    padding: 1.25rem 0 1.25rem;
  }

  .header-editorial-container {
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;

    .left-arrow {

      svg {
        fill: $grey;
      }

      @include mobile {
        width: 1rem;
        height: 1rem;
      }
    }

    .arrow-text {
      margin-left: 0.5rem;
      font-size: 1rem;
      color: $grey;

      @include mobile {
        margin-left: 0.5rem;
        font-size: 0.75rem;
        color: $grey;
      }
    }
  }

  .gender {
    text-transform: uppercase;
    color: $grey-lighter;

    .gender-item {
      display: inline;
      cursor: pointer;
      padding-right: 0.75rem;
      border-right: 1px solid $grey-lighter;

      @include tablet {
        font-size: 1.25rem;
      }

      &:last-child {
        border-right: none;
        padding-right: 0;
        padding-left: 0.75rem;
      }

      &:hover {
        color: #888888;
      }
    }

    .active {
      color: $grey-text;
    }
  }

  .detail-view-hint-mobile {
    font-size: 0.875rem;
    margin: 0.25rem 0;
    letter-spacing: 0.031rem;
    display: none;

    @include tablet {
      margin: 0;
      padding: 0 1.2rem;
      display: block;
    }
  }

  .detail-view-hint {
    font-size: 1rem;
    height: 2.75rem;
    line-height: 1.25rem;
    //padding-left: 2.75rem;
    max-width: 36.5rem;
    letter-spacing: 0;
    color: $grey;

    @include mobile {
      display: none;
    }
  }

  .settings {
    font-size: 0.75rem;

    @include tablet {
      font-size: 0.875rem;
    }

    .mobile,
    .desktop {
      > div {
        display: inline;
        margin-left: 1.5rem;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .mobile {
      display: block;

      svg {
        vertical-align: middle;
      }

      @include tablet {
        display: none;
      }

      .heart {
        display: inline-block;
        position: relative;
        width: 1rem;
        height: 1rem;

        &.red {
          svg {
            fill: $ny-red;
          }
        }

        svg {
          fill: $grey-lighter;
          width: 1rem;
          height: 1rem;
        }

        .likes-count {
          position: absolute;
          top: 0;
          right: 0;
          transform: translate(75%, -25%);
          background: $grey-lighter;
          border-radius: 100%;
          font-size: 0.5rem;
          font-weight: 400;
          color: $grey;
          padding: 0.125rem 0.25rem;
        }
      }
    }

    .desktop {
      display: none;

      @include tablet {
        display: block;
      }

      .filter {
        cursor: pointer;
        position: relative;

        .filter-modal {
          display: none;
          position: absolute;
          padding: 1.25rem;
          background-color: $white;
          border: solid 1px $grey-lighter;
          z-index: 1;
          top: 1.5rem;
          right: 0;
          text-align: right;
          cursor: auto;
          min-width: 160px;

          &.show {
            display: block;
          }

          .filters {
            > div {
              padding-top: 0.25rem;
              padding-bottom: 0.25rem;
            }

            > div:first-child {
              padding-top: 0;
            }

            > div:last-child {
              padding-bottom: 0;
            }

            .item {
              cursor: pointer;
              text-decoration: none;
              color: inherit;
              > span:first-child {
                margin-right: 0.5rem;
              }
              > span:nth-child(2) {
                cursor: pointer;
              }

              @include tablet {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
              }
            }
          }
        }

        .filter-modal-background {
          cursor: default;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      .count {
        display: inline;
        cursor: auto;

        > span {
          cursor: pointer;
          color: $grey-lighter;
          padding-right: 0.5rem;
          border-right: 1px solid $grey-lighter;

          &.active {
            color: $grey-text;
          }

          &:last-child {
            padding-right: 0;
            padding-left: 0.5rem;
            border-right: none;
          }

          &:hover {
            color: #888888;
          }
        }
      }
    }
  }
}
